<!--

USAGE:
Set class "tooltip" on content that should be hoverable, and add Tooltip-component inside.

-->

<template>
  <span v-if="!hidden"
    @mouseover="hide"
    v-bind:class="{ hidden: hidden }"
    class="tooltiptext">{{text}}
  </span>
</template>

<script>
export default {
  name: 'tooltip',
  props: {
    text: String,
  },
  data () {
    return {
      hidden: false,
    };
  },
  methods: {
    hide () {
      this.hidden = true;
      setTimeout(() => {
        this.hidden = false;
      }, 200);
    },
  },
};
</script>

<style lang="scss">
.tooltip .tooltiptext {
    visibility: hidden;
    min-width: 120px;
    height: 40px;
    background-color: rgba(118, 118, 118, 70);
    color: #fff;
    text-align: center;
    padding: 10px 5px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    bottom: calc(100% + 10px);
    left: 100%;
    margin-left: -60px; /* Use half of the width (120/2 = 60), to center the tooltip */
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}
.tooltip .tooltiptext::after {
    content: " ";
    position: absolute;
    top: 100%; /* At the bottom of the tooltip */
    left: 36px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: rgba(118, 118, 118, 70) transparent transparent transparent;
    z-index: 10;
}
</style>
